import { Injectable } from '@angular/core';
import { PouchdbService } from '../shared/pouchDb.service';
import { Constants } from '../shared/models/constants'
import { BookData } from '../shared/models/bookData';
import { ShelfValues } from '../shared/models/shelfEnums';
import { Page } from '../shared/models/page';
import { Book } from '../shared/models/book';
import { Subject } from 'rxjs';
import { PageContent } from '../shared/models/pageContent';
import { LiquidModel } from '../shared/models/liquidModel';

@Injectable()
export class ELEpouchdbService {

    noteData: Subject<any> = new Subject();
    notesData$ = this.noteData.asObservable();

    localDB; remoteDB;
    bookDataObj: BookData = new BookData();

    constructor(public pouchService: PouchdbService) {
        this.localDB = pouchService.localDB;
    }


    getPages(bookObj, scope) {
        var _this = this;
        if (bookObj.bookDataDocId == undefined)
            bookObj.bookDataDocId = "Not Defined";
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookObj.bookDataDocId },
        }).then(function (result) {
            if (result.docs.length == 0) {

                scope.loadEnrichmentTabs();
            }
            else if (result.docs.length > 0) {
                var bookData = result.docs[0];
                //_this.getBookData(bookData);
                scope.loadEnrichmentTabs();
                // scope.setbookData(bookData);
                _this.getPageContent(bookData[bookData.lastOpenedPage].contentDocId, scope, bookData.lastOpenedPage);
            }
        }).catch(function (err) {

        });
    }

    getPageContent(id, scope, timeStamp) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {

                scope.setPageConent(result.docs[0], timeStamp);
            }
        }).catch(function (err) {

        });
    }
    async updateBookObj(bookObj) {
        var self = this;
        //
        await this.pouchService.localDB.find({
            selector: { type: 'book', _id: bookObj._id },
        }).then(async function (result) {
            if (result.docs.length > 0) {

                result.docs[0].pageCount = bookObj.pageCount;

                return await self.pouchService.localDB.put(result.docs[0]).then(function (response) {

                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });

    }

    savenote() {

        this.noteData.next();
    }
    async updateBookDataObj(bookDataObj, bookObj) {
        var self = this;
        //
        await this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookDataObj._id },
        }).then(async function (result) {
            if (result.docs.length > 0) {

                bookDataObj._rev = result.docs[0]._rev;
                result.docs[0] = bookDataObj;

                return await self.pouchService.localDB.put(result.docs[0]).then(function (response) {
                    console.log(response);
                    // self.getPages(bookObj,"","");
                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });

    }

    async createPageContentDoc(pageContent, scope) {
        var self = this;

        await self.pouchService.localDB.put(pageContent).then(async function (result) {


            if (scope) await scope.setPageConent(pageContent);

        }).catch(function (err) {

        })
    }
    getTemplatePageContent(id) {
        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }

    addBookdataObj(bookdata) {

        var self = this;

        self.pouchService.localDB.put(bookdata).then(function (result) {



        }).catch(function (err) {

        })
    }

}



// WEBPACK FOOTER //
// ./src/app/ELE/ELE.pouchdb.service.ts